import { render } from "./PostNotesModal.vue?vue&type=template&id=f64bb344&ts=true"
import script from "./PostNotesModal.vue?vue&type=script&lang=ts"
export * from "./PostNotesModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__